// extracted by mini-css-extract-plugin
export var change = "_3x-1";
export var changeList = "_3x-0";
export var changePath = "_3x-2";
export var diffArrow = "_3x-5";
export var diffRow = "_3x-3";
export var diffValue = "_3x-4";
export var error = "_3x-8";
export var notice = "_3x-9";
export var result = "_3x-6";
export var success = "_3x-7";